<div class="top-title-main">
    <div class="divider">
        <div class="pageTitle" style="float: left">Unassigned Accounts</div>
    </div>
    <div class="top-action-btn-content" style="display:inline-block">
        <button class="btn-large-secondary" (click)="showImportAccountsToPortfolioDialog()">Import</button>
        <button style="position: relative;"  [matMenuTriggerFor]="subMenu1" [disabled]="disableActionBtn" class="btn-large-primary btnWithArrow"
        >Actions<i class="material-icons md-24 md-align dropdown-arrow-align" >arrow_drop_down</i>
            <div *ngIf="disableActionBtn" style="position:absolute;left:0;top:0;z-index: 9999; width: 104px; height: 32px" tooltip [tooltipPosition]="'right'" [tooltipTitle]="'Activate &quot;Actions&quot; by first selecting the checkboxes for the accounts below'"></div>
        </button>
        <button style="position: relative;" [matMenuTriggerFor]="subMenuSAC" class="btn-large-secondary btnWithArrow"
        >Go to SAC<i class="material-icons md-24 md-align dropdown-arrow-align" >arrow_drop_down</i>
            <mat-menu #subMenuSAC="matMenu" class="nav__items_action_btn" yPosition="below">
                <button class="nav__item_action_btn external" mat-menu-item (click)="window.open(redirectURL + '/?sanc=A_BAL','_blank')">Balances</button>
                <button class="nav__item_action_btn external" mat-menu-item (click)="window.open(redirectURL + '/?sanc=A_POS','_blank')">Positions</button>
            </mat-menu>
        </button>
    </div>
    <div *ngIf="isUnassignActEnabled" style="display:inline-block;vertical-align:top;">
        <div class="divider"></div>
        <div class="toggle-container" style="display: flex; align-items: center;margin-top: 10px;">
            <label class="toggle-label" style="margin-right: 8px; font-weight: 600;">Show Hidden Accounts</label>
            <mat-slide-toggle (change)="onToggleAccountsEnabled($event)" [(checked)]="ENABLE_UNASSIGNED_ACCOUNTS"></mat-slide-toggle>

            <span class="infoIcon"
                  calltoaction
                  [calltoactionTemplate]="hiddenAccountsTemplateRef"
                  calltoactionPosition="bottom" style="margin-left: 8px;"></span>
            <ng-template #hiddenAccountsTemplateRef>
                Hidden accounts are not displayed by default. Toggle to view them.
            </ng-template>
        </div>
    </div>

</div>

<irb-filter-chips [filterData]="_filterChipModel" [dataMap]="filterDisplayNamesData" (removeFilterItem)="onRemoveFilterItem($event)" [context]="loadingOverlayComponentParams"></irb-filter-chips>
<irb-inventory-grid *ngIf="!isUiTest" class="show-grid-toolbar-buttons"
        [style.minHeight]="'600px'"
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)"
        [loadingOverlayComponent]="'customLoadingOverlay'"
        [loadingOverlayComponentParams]="loadingOverlayComponentParams"
        [componentName]="componentName"
        [footerContent] = "footerContent"
        [contextMenuItems]="getContextMenuItems()"
        [noRowsOverlayComponent]="'customNoRowOverlay'"
        [noRowsOverlayComponentParams]="loadingOverlayComponentParams"
        [showFiltersColumns]="true"
></irb-inventory-grid>

<mat-menu #subMenu1="matMenu" class="nav__items_action_btn" yPosition="below">
    <button class="nav__item_action_btn" mat-menu-item (click)="assignToExistingPortfolio()">Assign selected accounts to a single household</button>
    <button class="nav__item_action_btn" mat-menu-item (click)="assignToOwnPortfolio()">Assign each selected account to its own portfolio</button>
    <button class="nav__item_action_btn" mat-menu-item (click)="hideSelectedAccounts()" *ngIf="isUnassignActEnabled && showHideAction()">Hide selected accounts</button>
    <button class="nav__item_action_btn" mat-menu-item (click)="restoreSelectedAccounts()" *ngIf="isUnassignActEnabled && showRestoreAction()">Restore selected accounts</button>
    <button class="nav__item_action_btn" mat-menu-item [matMenuTriggerFor]="export">Export</button>
</mat-menu>

<mat-menu #export="matMenu" class="nav__items_action_btn isSubMenu">
    <button class="nav__item_action_btn" mat-menu-item (click)="exportAccountDetails()">Account Details</button>
</mat-menu>

<ng-template #accountNumberOverlay>
    <div *ngIf="row">
        <div class="hblock" style="color: #999; font-size: 11px;">Account Assignment</div>
        <div style="padding-left: 10px">
            <div class="hblock clickable" (click)="assignToExistingPortfolio(row?.id)">Assign to Portfolio</div>
        </div>
        <ng-container *ngIf="isUnassignActEnabled">
            <div class="hblock" style="color: #999; font-size: 11px;">Account Visibility</div>
            <div style="padding-left: 10px">
                <div class="hblock clickable" *ngIf="row?.actIsVisible !== false" (click)="hideAccount(row)">Hide Account</div>
                <div class="hblock clickable" *ngIf="row?.actIsVisible === false" (click)="restoreAccount(row)">Restore Account</div>
            </div>
        </ng-container>
        <div class="hblock" style="color: #999; font-size: 11px;">Export</div>
        <div style="padding-left: 10px">
            <div class="hblock clickable" (click)="exportAccountDetails(row?.id)">Account Details</div>
        </div>
        <hr style="margin: 8px 0; border: none; border-top: 1px solid #e0e0e0;">
        <div class="hblock" style="color: #999; font-size: 11px;">Go to SAC</div>
        <div style="padding-left: 10px">
            <div class="hblock clickable" *ngFor="let item of sacMenuItems" (click)="openSACWithContext(item.sanc); closeMenu(); $event.stopPropagation();">
                {{item.label}} <i class="material-icons" style="font-size: 16px; color: #666; float: right;">open_in_new</i>
            </div>
        </div>
    </div>
</ng-template>


